import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';
import type { IBill } from '../types/Bill';

type BillsApiMembershipParam = Pick<IBill, 'membershipId'>;

export interface SubmitBillDiscoveryReviewBody {
    acceptedBillIds: string[];
    rejectedBillIds: string[];
    reviewedAccountIds: string[];
}

const useSubmitBillDiscoveryReview = requestBuilder.mutation<
    GeneralResponse,
    SubmitBillDiscoveryReviewBody,
    BillsApiMembershipParam
>({
    endpoint: ({ membershipId }) =>
        `/api/holistic-bills/${membershipId}/discovery-review/submit`,
    method: 'POST',
});

export default useSubmitBillDiscoveryReview;
